<sz-app-shell>
  <sz-top-bar />

  @if (drill(); as d) {
    <div class="quick-setup">
      <sz-page-title [title]="d.name" size="xl" [showBack]="true">
        <div szTitleKicker class="quick-setup__kicker">
          <span>{{ 'session.quickSetup.kicker' | translate }}</span>
          <span class="quick-setup__kicker-sep">·</span>
          <span>{{ 'session.quickSetup.kickerSub' | translate }}</span>
        </div>
        <div szTitleSub class="quick-setup__sub">
          <sz-type-pill [type]="d.typeLabel === 'Live' ? 'Live' : 'Dry'" />
          <sz-score-chip [scoring]="d.scoring" />
        </div>
      </sz-page-title>

      <sz-section-head
        [label]="'session.quickSetup.targetRunsLabel' | translate"
        [count]="'session.quickSetup.targetRunsOptional' | translate" />

      <div class="quick-setup__presets">
        @for (preset of presets; track preset) {
          <button
            type="button"
            class="quick-setup__preset"
            [class.quick-setup__preset--selected]="selectedPreset() === preset"
            (click)="selectPreset(preset)">
            <span class="quick-setup__preset-value">{{ preset }}</span>
            <span class="quick-setup__preset-unit">{{ 'session.quickSetup.presetRunsLabel' | translate }}</span>
          </button>
        }
      </div>

      <div class="quick-setup__options">
        <button
          type="button"
          class="quick-setup__option"
          [class.quick-setup__option--selected]="customSelected()"
          (click)="selectCustom()">
          <span class="quick-setup__option-title">{{ 'session.quickSetup.customLabel' | translate }}</span>
          <span class="quick-setup__option-sub">{{ customSubLabel() }}</span>
        </button>
        <button
          type="button"
          class="quick-setup__option quick-setup__option--subtle"
          [class.quick-setup__option--selected]="noneSelected()"
          (click)="selectNone()">
          <span class="quick-setup__option-title">{{ 'session.quickSetup.noTargetLabel' | translate }}</span>
          <span class="quick-setup__option-sub">{{ 'session.quickSetup.noTargetSub' | translate }}</span>
        </button>
      </div>
    </div>

    <sz-cta-bar variant="floating">
      <sz-button variant="primary" [fullWidth]="true" [disabled]="!canStart()" (click)="start()">
        <sz-icon name="play" [size]="16" />
        {{ 'common.startSession' | translate }}
      </sz-button>
    </sz-cta-bar>
  } @else {
    <div class="quick-setup__skeleton">
      <sz-skeleton shape="text" width="40%" height="12px" />
      <sz-skeleton shape="text" width="60%" height="34px" />
      <sz-skeleton shape="text" width="45%" height="20px" />
      <sz-skeleton shape="block" height="72px" />
      <sz-skeleton shape="block" height="120px" />
    </div>
  }
</sz-app-shell>

<sz-bottom-sheet [open]="customSheetOpen()" (close)="closeCustomSheet()">
  <div szSheetHeader class="quick-setup__sheet-head">
    <div class="quick-setup__sheet-head-text">
      <div class="quick-setup__sheet-kicker">{{ 'session.quickSetup.kicker' | translate }}</div>
      <div class="quick-setup__sheet-title">{{ 'session.quickSetup.customLabel' | translate }}</div>
    </div>
    <sz-icon-button icon="x" size="sm" [ariaLabel]="'common.close' | translate" (click)="closeCustomSheet()" />
  </div>

  <div class="quick-setup__custom-numpad">
    <div class="quick-setup__custom-display">
      <sz-num-focal [value]="customDisplay()" [unit]="'session.quickSetup.presetRunsLabel' | translate" size="xl" />
    </div>
    <sz-numpad-grid [keys]="numpadKeys()" (press)="onCustomKeyPress($event)" />
    <div class="quick-setup__sheet-footer">
      <sz-button variant="secondary" size="sm" (click)="closeCustomSheet()">
        {{ 'common.cancel' | translate }}
      </sz-button>
      <sz-button variant="primary" [disabled]="!canSaveCustom()" (click)="saveCustom()">
        <sz-icon name="check" [size]="16" />
        {{ 'common.save' | translate }}
      </sz-button>
    </div>
  </div>
</sz-bottom-sheet>
